import CarModel         from './CarModel.vue';
import CarBrands        from './CarBrands.vue';
import CarModelList     from './CarModelList.vue';
import CarCategories    from './CarCategories.vue';
import CarSearchButton  from './CarSearchButton.vue';

import ModelYear        from './ModelYear.vue';
import ModelType        from './ModelType.vue';

import ProductFilter    from './ProductFilter.vue';

export default {

        components: {
            'car-model': CarModel,
            'car-brands': CarBrands,
            'car-model-list': CarModelList,
            'car-categories': CarCategories,
            'car-search-button': CarSearchButton,

            'model-year': ModelYear,
            'model-type': ModelType,

            'product-filter': ProductFilter
        },

        register: function (Vue) {
            for(let component in this.components) {
                Vue.component(component, this.components[component]);
            }
        }
}


